module.exports = "/assets/8c62f35e1bdc95c4df3e6b8c7e8f402d.svg";